export default __webpack_public_path__ + "static/media/roboto-400-regular.49ae34d4.woff";